import { useState } from 'react';
import { Link } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import { Button, Menu, MenuProps, MenuItem, Typography, Box } from '@mui/material';
import { Image, KeyboardArrowDown, Videocam } from '@mui/icons-material';

type TypeProps = { screenshotsLink: string; videoLink: string };

const StyledBox = styled(Box)({
  display: 'flex',
  alignSelf: 'stretch',
});

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: 'rgb(55, 65, 81)',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}));

export const DownloadMenu = ({ screenshotsLink, videoLink }: TypeProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <StyledBox>
      <Button
        id='download-button'
        aria-controls={open ? 'download-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='contained'
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDown />}
      >
        Download
      </Button>
      <StyledMenu
        id='demo-customized-menu'
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Link style={{ textDecoration: 'none' }} to={screenshotsLink} target='_blank'>
          <MenuItem disableRipple>
            <Image />
            <Typography>Screenshots</Typography>
          </MenuItem>
        </Link>

        <Link style={{ textDecoration: 'none' }} to={videoLink} target='_blank'>
          <MenuItem disableRipple>
            <Videocam />
            Video
          </MenuItem>
        </Link>
      </StyledMenu>
    </StyledBox>
  );
};
